import React from 'react';

import TimeUnits from '@swf/components/TimeUnits/TimeUnits';
import { convertMilliseconds } from '@swf/core/utils';

export interface Props {
  time: number;
  count: number;
}

const timeBreakMinutes = 23 * 60 + 59;

const formatZero = (value: number) => (value < 10 ? '0' + value.toString() : value.toString());

const formatTime = (ms: number) => {
  const time = convertMilliseconds(ms);
  let myDay = time.days;
  let myHrs = formatZero(time.hours);
  let myMin = formatZero(time.minutes);
  let mySec = formatZero(time.seconds);

  if (time.hours >= 1) {
    if (time.minutes > timeBreakMinutes) {
      if (time.hours % 24 > 0) {
        myDay = time.days + 1;
      }
      myHrs = '';
      myMin = '';
      mySec = '';
    }

    if (time.minutes <= timeBreakMinutes) {
      if (time.seconds > 0) {
        if (time.minutes === 59) {
          myMin = '00';
          myHrs = (time.hours + 1).toString();
        } else {
          myMin = formatZero(time.minutes + 1);
          myHrs = time.hours.toString();
        }
      } else {
        myMin = formatZero(time.minutes);
        myHrs = time.hours.toString();
      }
      mySec = '';
    }
  } else {
    myMin = formatZero(time.minutes);
    mySec = formatZero(time.seconds);
  }

  return {
    days: myDay,
    hours: myHrs,
    minutes: myMin,
    seconds: mySec
  };
};

const StifledCountdown: React.FC<Props> = ({ time, count }) => {
  const { days, hours, minutes, seconds } = formatTime(Math.abs(time - count));
  if (days) {
    return <TimeUnits days={days} />;
  }

  return <span>{hours !== '00' ? `${hours}:${minutes}` : `${minutes}:${seconds}`}</span>;
};

export default StifledCountdown;
